import { fork } from "redux-saga/effects";

import utilsSagas from "../utils/sagas";
import rewardsSagas from "../shells/Rewards/sagas";
import rulesSagas from "../shells/Rules/sagas";
import ErrorSagas from "../shells/ErrorComponent/sagas";
import matchinfoSagas from "../shells/MatchInfo/sagas";
import leaderboardSagas from "../shells/Leaderboard/sagas";
import historySagas from "../shells/HistoryLeaderboard/sagas";
import oldleaderboardSagas from "../shells/oldLeaderboard/sagas";
import earnpointsSagas from "../shells/EarnPoints/sagas";
import weekprizesSagas from "../shells/WeeksPrizes/sagas";
import helpSagas from "../shells/HelpSection/sagas";
import openRewardsSagas from "../shells/RewardOpening/sagas";
import marketingPrizesSagas from "../shells/Prizes/sagas";

const sagas = [...utilsSagas, ...rewardsSagas, ...rulesSagas, ...ErrorSagas, ...matchinfoSagas, ...leaderboardSagas, ...historySagas, ...oldleaderboardSagas, ...earnpointsSagas, ...weekprizesSagas, ...helpSagas, ...openRewardsSagas, ...marketingPrizesSagas];

export default function* root() {
  yield sagas.map(saga => fork(saga));
}



// WEBPACK FOOTER //
// ./src/root/sagas.js